import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const RiskViewWrapper = styled.div`
  background: ${colors.white100};
  border-radius: 4px;
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 20%),
    0 1px 1px 0 rgb(0 0 0 / 14%),
    0 0 0 0 rgb(0 0 0 / 12%);
  padding: 16px;
  min-width: 85%;
  max-width: 85%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
  }

  .MuiTablePagination-root {
    border: none;
  }

  .MuiTabs-root {
    margin: 0;
  }
`

export const TotalCount = styled.div`
  text-align: right;
  font-size: 14px;
  padding-top: 16px;
`
